import { Typography } from "@mui/material";
import type { AuthPageType } from "Components/Auth/Shared/AuthPageLayout";
import { AuthFooterSection } from "Components/Auth/Shared/AuthStyledComponents";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { Resources, useResource } from "Translations/Resources";
import { getAppUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Auth.AuthPageLayout;

type Props = {
  pageType: AuthPageType;
};

/** The prompt below the auth card: sign-in pages point to sign-up, every other page to sign-in. */
export const AuthPageFooter = ({ pageType }: Props) => {
  const { t } = useResource();
  const appUrl = getAppUrl();
  const isSignIn = pageType === "sign-in";

  return (
    <AuthFooterSection alignItems="center" gap="6px" justifyContent="center">
      <Typography>
        {t(isSignIn ? RESOURCES.SignUpPrompt : RESOURCES.SignInPrompt)}
      </Typography>
      <UnstyledLink to={appUrl(isSignIn ? "sign-up" : "sign-in")}>
        {t(isSignIn ? RESOURCES.SignUpLinkText : RESOURCES.SignInLinkText)}
      </UnstyledLink>
    </AuthFooterSection>
  );
};
